import { ResetPasswordModalTranslations } from "./types";

export const deTranslations: ResetPasswordModalTranslations = {
    title: "Passwort zurücksetzen",
    subTitle:
        "Dies sendet eine Passwortzurücksetzungsanfrage an diesen Benutzer. Bestätigen?",
    confirm: "Bestätigen",
};
